import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function ConfirmDialog({
  open,
  onOpenChange,
  title = "Are you sure?",
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  testID,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testID} className="border-rig-border bg-rig-surface">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display tracking-wide text-white">{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription className="text-rig-dim">{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" className="border-rig-borderStrong bg-transparent text-white hover:bg-rig-surface2">
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-accept"
            onClick={onConfirm}
            className={
              destructive
                ? "bg-rig-error text-white hover:bg-rig-error/90"
                : "bg-rig-accent text-rig-accentText hover:bg-rig-accentDark"
            }
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
